var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bolt-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF00FF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#FF00FF;#00FFFF;#FFFF00;#FF00FF",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#00FFFF;#FFFF00;#FF00FF;#00FFFF",
    dur: "4s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "bolt-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L7 18H15L12 30L25 14H17L16 2Z",
    stroke: "url(#bolt-gradient)",
    strokeWidth: 2,
    filter: "url(#bolt-glow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "0,100;100,0;100,0;100,0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keyTimes: "0;0.45;0.5;1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L7 18H15L12 30L25 14H17L16 2Z",
    fill: "white",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0",
    dur: "3s",
    repeatCount: "indefinite",
    calcMode: "discrete",
    keyTimes: "0;0.45;0.5;0.8;0.85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashBolt);
export default __webpack_public_path__ + "static/media/flash-bolt.41595c2bfc18defa6233ceb8fcfe7a88.svg";
export { ForwardRef as ReactComponent };